import { fetchPalmettoUsers } from './fetchPalmettoUsersThunk';
export default fetchPalmettoUsers;
